function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["isMulti", "customComponents", "isCheckbox", "isCheckboxOnGroupHeading", "onApply", "onChange", "onMenuClose", "onOutsideClick", "value", "isMenuVisibleOnFocus", "noInteractionBorder"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useEffect } from "react";
import { bool, func, string } from "prop-types";
import { components } from "react-select";
import { Select } from "#library/components/SelectFilter/Select/Select";
import { selectTypes } from "#library/components/SelectFilter/Select/types/types";
import { selectDefaultProps } from "#library/components/SelectFilter/Select/defaultProps/defaultProps";
import { MenuList, MenuListTags, MenuListCheckbox, ValueContainerMulti, ClearIndicator, IndicatorsContainer, GroupHeadingCheckbox, Option, OptionCheckbox, GroupCheckbox } from "#library/components/SelectFilter/customComponents";

// TODO: the filter placeholder container wraps when the filter width is too small, creating some weird UI,
// we need to find a solution to avoid having issues when this component has a small width

// TODO: We could improve the accessibility for the component :
// * Possible to focus the "X" to clear selected labels but not possible to validate it with keyboard (enter, space, ...)
// * When the dropdown is open it is not possible to go to "Clear" or "Apply" with keyboard. Tab key is used to select checkbox inside dropdown
export var Filter = function Filter(props) {
  var isMulti = props.isMulti,
    customComponents = props.customComponents,
    isCheckbox = props.isCheckbox,
    isCheckboxOnGroupHeading = props.isCheckboxOnGroupHeading,
    _onApply = props.onApply,
    _onChange = props.onChange,
    _onMenuClose = props.onMenuClose,
    onOutsideClick = props.onOutsideClick,
    value = props.value,
    isMenuVisibleOnFocus = props.isMenuVisibleOnFocus,
    noInteractionBorder = props.noInteractionBorder,
    restProps = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line no-nested-ternary
  var _useState = useState(value || (isMulti ? [] : undefined)),
    _useState2 = _slicedToArray(_useState, 2),
    backupValue = _useState2[0],
    setBackupValue = _useState2[1];
  var _useState3 = useState(backupValue),
    _useState4 = _slicedToArray(_useState3, 2),
    currentValue = _useState4[0],
    setCurrentValue = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hasApplied = _useState6[0],
    setHasApplied = _useState6[1];
  useEffect(function () {
    var newValue = value || (isMulti ? [] : undefined);
    setBackupValue(newValue);
    setCurrentValue(newValue);
  }, [value, isMulti]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    isMulti: isMulti,
    value: currentValue,
    customComponents: _objectSpread({
      IndicatorsContainer: isMulti ? IndicatorsContainer : components.IndicatorsContainer,
      ClearIndicator: isMulti ? function () {
        return null;
      } : ClearIndicator,
      MenuList: isMulti ? isCheckbox ? MenuListCheckbox : MenuListTags : MenuList,
      ValueContainer: isMulti ? ValueContainerMulti : components.ValueContainer,
      GroupHeading: isCheckbox && isCheckboxOnGroupHeading ? GroupHeadingCheckbox : components.GroupHeading,
      Option: isCheckbox ? OptionCheckbox : Option,
      Group: isCheckbox ? GroupCheckbox : components.Group
    }, customComponents),
    closeMenuOnSelect: !isMulti,
    hideSelectedOptions: !isCheckbox,
    isCheckbox: isCheckbox,
    onMenuOpen: function onMenuOpen() {
      setHasApplied(false);
    },
    onMenuClose: function onMenuClose() {
      setCurrentValue(backupValue);
      _onMenuClose(currentValue);
      if (!hasApplied) {
        onOutsideClick(currentValue);
      }
    },
    onApply: function onApply(nextValue) {
      setHasApplied(true);
      setBackupValue(nextValue);
      _onApply(nextValue);
    },
    onChange: function onChange(nextValue, triggeredAction) {
      setCurrentValue(nextValue);
      if (!isMulti) {
        setBackupValue(nextValue);
        _onApply(nextValue);
      }
      _onChange(nextValue, triggeredAction);
    },
    isMenuVisibleOnFocus: isMenuVisibleOnFocus,
    noInteractionBorder: noInteractionBorder
  }, restProps));
};
Filter.propTypes = _objectSpread(_objectSpread({}, selectTypes), {}, {
  clearLabel: string,
  applyLabel: string,
  selectAllLabel: string,
  indicatorClearLabel: string,
  isCheckbox: bool,
  isCheckboxOnGroupHeading: bool,
  isMulti: bool,
  leftIconId: string,
  hideIndicatorOnSingleSelection: bool,
  displayValueOnSingleSelection: bool,
  onApply: func,
  onOutsideClick: func,
  onChange: func
});
Filter.defaultProps = _objectSpread(_objectSpread({}, selectDefaultProps), {}, {
  clearLabel: "Clear",
  applyLabel: "Apply",
  selectAllLabel: null,
  indicatorClearLabel: "Clear",
  isCheckbox: false,
  isCheckboxOnGroupHeading: true,
  isMulti: false,
  leftIconId: "",
  hideIndicatorOnSingleSelection: false,
  displayValueOnSingleSelection: false,
  onApply: function onApply() {},
  onChange: function onChange() {},
  onOutsideClick: function onOutsideClick() {},
  onMenuClose: function onMenuClose() {}
});